const googleRAAPProperties = [

  {destination: 'id', origin: 'sku', isRequired: true},
  {destination: 'region_id', origin: 'regionId', isRequired: true},
  {destination: 'availability', origin: 'availability', isRequired: true},
  {destination: 'price', origin: 'price', isRequired: true},
  {destination: 'sale_price', origin: 'salePrice', isRequired: false},
  {destination: 'sale_price_effective_date', origin: 'salePriceEffectiveDate', isRequired: false},
]


export default googleRAAPProperties;
